var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 10.125L3.67661 7.78627C4.24491 7.20877 5.16909 7.18694 5.764 7.73699L10.375 12",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.75L13.0469 2.75C13.0469 2.75 13.0469 0.75 11.5 0.750033H7.54688C7.04688 0.749993 5.872 0.75 5.21515 0.75H2.5C1.67157 0.75 1 1.42157 1 2.25V10.5C1 11.3284 1.67157 12 2.5 12H11.5C12.3284 12 13 11.3284 13 10.5V9.75Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 5.25C4.99632 5.25 5.5 4.74632 5.5 4.125C5.5 3.50368 4.99632 3 4.375 3C3.75368 3 3.25 3.50368 3.25 4.125C3.25 4.74632 3.75368 5.25 4.375 5.25Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon2);
export default __webpack_public_path__ + "static/media/imageIcon2.513a9dce0caa7b2b2744e7f3fe3c747a.svg";
export { ForwardRef as ReactComponent };